import {Button} from '@prtimes-basis/button';
import {type CSSProperties} from 'react';
import {FormStepIndicator} from '../../components/form-step-indicator';
import {type FormSchema} from '../../form';
import {ConfirmCompanyInformationSection} from './confirm-company-information-section';
import {ConfirmContactPersonInformationSection} from './confirm-contact-person-information-section';
import {ConfirmBillingInformationSection} from './confirm-billing-information-section';
import {useDiscardModalEffect} from './use-discard-modal-effect';
import styles from './confirm-step.module.css';

type Props = {
  readonly formValues: FormSchema;
  readonly onClickEdit: () => void;
  readonly onClickSubmit: () => void;
  readonly isDisabled: boolean;
};

export function ConfirmStep({
  formValues,
  onClickEdit,
  onClickSubmit,
  isDisabled,
}: Props) {
  useDiscardModalEffect();
  // コンバージョンを計測するためのID
  const conversionAnalyticsIdTop = 'submit-company-registration-conversion-top';
  const conversionAnalyticsIdBottom =
    'submit-company-registration-conversion-bottom';

  return (
    <div className={styles.container}>
      <div className={styles.overview}>
        <div className={styles.description}>
          <h1 className={styles.heading}>PR TIMESに企業登録申請</h1>

          <p className={styles.detail}>
            <span>
              内容をご確認いただき、「申請する」ボタンをクリックしてください。
            </span>
            <span>
              内容を修正する場合は、「入力内容を修正する」ボタンから編集画面に戻って編集を行ってください。
            </span>
          </p>
        </div>

        <FormStepIndicator step={2} />
      </div>

      <div className={styles.buttonContainer}>
        <Button
          type='button'
          variant='flat'
          color='secondary'
          disabled={isDisabled}
          style={buttonInlineStyle}
          onClick={onClickEdit}
        >
          入力内容を修正する
        </Button>
        <Button
          id={conversionAnalyticsIdTop}
          type='button'
          variant='flat'
          color='primary'
          disabled={isDisabled}
          style={buttonInlineStyle}
          onClick={onClickSubmit}
        >
          申請する
        </Button>
      </div>

      <div className={styles.sections}>
        <ConfirmCompanyInformationSection
          companyInfo={formValues.companyInfo}
        />
        <ConfirmContactPersonInformationSection
          contactPersonInfo={formValues.contactPersonInfo}
        />
        <ConfirmBillingInformationSection
          billingInfo={formValues.billingInfo}
        />
      </div>

      <div className={styles.buttonContainer}>
        <Button
          type='button'
          variant='flat'
          color='secondary'
          disabled={isDisabled}
          style={buttonInlineStyle}
          onClick={onClickEdit}
        >
          入力内容を修正する
        </Button>
        <Button
          type='button'
          variant='flat'
          color='primary'
          id={conversionAnalyticsIdBottom}
          disabled={isDisabled}
          style={buttonInlineStyle}
          onClick={onClickSubmit}
        >
          申請する
        </Button>
      </div>
    </div>
  );
}

const buttonInlineStyle = {
  height: 53,
  fontSize: 'var(--font-size-md)',
  whiteSpace: 'nowrap',
  fontWeight: 'bold',
} satisfies CSSProperties;
